"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    commandStatus200: {
        en: "The command was sent successfully to unit {description}, wait for a response.",
        es: "El comando fue enviado correctamente a la unidad {description}, espere por la respuesta.",
    },
    commandStatus102: {
        en: "{description} is starting to upload the video from the {name} camera.",
        es: "{description} empezó a subir el video del canal {name}.",
    },
    commandStatus201: {
        en: "The Unit {description} finished to upload the video from the {name} camera.",
        es: "La unidad {description} terminó de subir el video del canal {name}.",
    },
    commandStatus401: {
        en: "The Unit {description} refused the command.",
        es: "La unidad {description} rechazó el comando.",
    },
    commandStatus402: {
        en: "The Unit {description} couldn't find the video from the {name} camera, it could not be uploaded.",
        es: "La unidad {description} no pudo encontrar el video para el canal {name}, no se pudo subir.",
    },
    commandStatus403: {
        en: "The Unit {description} couldn't upload the video from the {name} camera, try again later.",
        es: "La unidad {description} no pudo subir el video del canal {name}, intente mas tarde.",
    },
    commandStatus404: {
        en: "The Unit {description} could not be reach, try again later.",
        es: "La unidad {description} no se pudo conectar, intente mas tarde.",
    },
    commandStatus405: {
        en: "There's a problem with unit {description}, please contact tech support.",
        es: "Hubo un problema con la unidad {description}, por favor contacte a soporte técnico.",
    },
    commandStatus406: {
        en: "There's a problem with unit {description}, please contact tech support.",
        es: "Hubo un problema con la unidad {description}, por favor contacte a soporte técnico.",
    },
    commandStatus407: {
        en: "Unit {description} is currently running another command, try again later.",
        es: "La unidad {description} está ejecutando otro comando actualmente , intente mas tarde.",
    },
    liveStatus100: {
        en: "Live transmission for the {name} camera is ready. Loading...",
        es: "La transmisión en vivo para el canal {name} esta lista. Cargando...",
    },
    liveStatus200: {
        en: "Live transmission for the {name} camera has ended.",
        es: "La transmisión en vivo para el canal {name} termino.",
    },
    liveError108: {
        en: "There was a problem with the memory card for unit {description}.",
        es: "Hubo un problema con la tarjeta de memoria de la unidad {description}.",
    },
    liveCommonError: {
        en: "There was a problem with the live transmission on the {name} camera.",
        es: "Hubo un problema con la transmisión en vivo en el canal {name}.",
    },
};
exports.default = translations;
